// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* custom button css */
.container {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  height: 32px;
  border: 1px solid #CCDCE4;
  border-radius: 32px;
  width: auto;
  padding: 8px;
  padding-left: 16px;
  padding-right: 16px;
  background: white;
}
.container:hover {
  background: #F0F4F8;
}
.container:active {
  background: #E0E8F0;
}

.icon {
}
.title {
  font-size: 16px;
  font-weight: 700;
  color: #4E758E;
  white-space: nowrap;
  user-select: none;
}
`, "",{"version":3,"sources":["webpack://./src/rounded-button.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;AACA;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB","sourcesContent":["/* custom button css */\n.container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  height: 32px;\n  border: 1px solid #CCDCE4;\n  border-radius: 32px;\n  width: auto;\n  padding: 8px;\n  padding-left: 16px;\n  padding-right: 16px;\n  background: white;\n}\n.container:hover {\n  background: #F0F4F8;\n}\n.container:active {\n  background: #E0E8F0;\n}\n\n.icon {\n}\n.title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #4E758E;\n  white-space: nowrap;\n  user-select: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
